/**
 * Adjuntos
 *
 */
import React from 'react'
import { message, Table, Button, Menu, Dropdown, Popconfirm, Modal, Icon, Divider } from 'antd'
import moment from 'moment'
import Cell from '../../../components/Cell'
import Api from '../../../Api'
import Exception from '../../../Exception'
import _ from 'lodash'
import { Crud } from '../../../components'

/**
 *
 * @param {number} docId
 * @returns {import('axios').AxiosPromise<{ maestro: { iIdUsuarioSolicita?: number, modeloId: number }, documentos: [], adjuntos: [] }>}
 */
function queryData(docId, opts) {
  const query = {
    maestro: {
      __returnType: 'one',
      model: opts.model,
      attributes: [
        'iId',
        opts.statusField,
        [{ fn: 'fn_kernel_get_modelo_id', params: [opts.model] }, 'modeloId']
      ],
      where: { iId: docId },
    },

    documentos: {
      model: 'AppDocumento',
    },

    adjuntos: {
      model: 'KernelAdjunto',
      attributes: [
        'iId',
        'iIdModelo',
        'iIdRegistro',
        'iIdAdjunto',
        'iIdKernelUsuarioRegistra',
        'dKernelFechaRegistro',
      ],
      include: [
        {
          as: 'archivo',
          required: true,
          attributes: ['sDescripcion']
        },
        {
          as: 'registra',
          required: true,
          attributes: ['sNombre']
        }
      ],
      where: {
        iIdRegistro: docId,
        $and: [{ $whereFn: ['fn_kernel_get_modelo_id', [opts.model], { $eq: '$iIdModelo$' }] }],
        iActivo: true
      }
    },
  }

  return Api.query.list(query)
}

/**
 *
 * @param {{ docId: number, model: string, isPending: (doc: any) }} props
 * @returns
 */
export function KernelAdjuntosTable(props) {
  const [loading, setLoading] = React.useState(false)
  const [documentos, setDocumentos] = React.useState([])
  const [records, setRecords] = React.useState([])
  const [master, setMaster] = React.useState()
  const { statusField, allowStatus } = props
  const statusValue = _.get(master, statusField)
  const masterIdPending = statusValue && (
    statusValue === allowStatus ||
    (props.isPending && props.isPending(master))
  )

  /**
   * fetch
   *
   */
  const fetch = () => {
    setLoading(true)

    queryData(props.docId, props)
      .then(response => {
        setMaster(response.data.maestro)
        setDocumentos(response.data.documentos)
        setRecords(response.data.adjuntos)
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        Exception.load(error).show()
      })
  }

  /**
   * uploadFile
   *
   */
  const uploadFile = async (file) => {
    const closeMessage = message.loading('Cargando', 0)
    const closeLoadings = () => {
      setLoading(false)
      closeMessage()
    }

    try {
      setLoading(false)

      const frm = Api.form({ upload: file, tipo: `WEB.${props.model}` })
      const upload = await Api.post('/upload/file', frm)
      await Api.post('/kernel/mutator', {
        model: 'KernelAdjunto',
        values: {
          iIdModelo: _.get(master, 'modeloId'),
          iIdRegistro: props.docId,
          iIdAdjunto: upload.data.iId,
        },
      })

      closeLoadings()
      message.success('Listo')
      fetch()
    } catch (e) {
      closeLoadings()
      Exception.load(e).show()
    }
  }

  /**
   * requestNewFile
   *
   * @param {{ sFiltro: string }} template
   */
  const requestNewFile = (template) => {
    if (!template) {
      return
    }

    var input = document.createElement('input')
    input.type = 'file'
    input.accept = template.sFiltro
    input.onchange = e => {
      if (input.files.length > 0) {
        uploadFile(input.files[0])
      }
      input.value = null
    }

    input.click()
  }

  /**
   * remove
   *
   * @param {number} id
   */
  const remove = (id) => {
    setLoading(true)

    const payload = {
      id,
      model: 'KernelAdjunto',
      values: { iActivo: false }
    }

    Api.post(`/kernel/mutator`, payload)
      .then(() => {
        message.success('Eliminado')
        setRecords(data => data.filter(i => i.iId.toString() !== id.toString()))
        setLoading(false)
      })
      .catch(error => {
        setLoading(false)
        Exception.load(error).show()
      })
  }

  /**
   * onChange(props.docId)
   *
   */
  React.useEffect(() => {
    fetch()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.docId])

  /**
   * columns
   */
  const columns = Cell.buildList([
    {
      title: 'NOMBRE', dataIndex: 'dKernelFechaRegistro', width: 200,
      render: (_, r) => (
        <span>
          <a href={Api.to(`/upload/file/${r.iIdAdjunto}`)} download={r.archivo.sDescripcion}>
            {r.archivo.sDescripcion}
          </a>
        </span>
      )
    },
    { title: 'FECHA', dataIndex: 'dKernelFechaRegistro', width: 150, render: val => val ? moment(val).format('DD MMM YY HH:mm A') : '' },
  ].concat(!masterIdPending ? [] : [
    {
      title: 'ACCIONES', dataIndex: 'dKernelFechaRegistro', width: 100,
      render: (_, record) => (
        <Popconfirm title='¿Eliminar?' onConfirm={() => remove(record.iId)}>
          <Button size='small' icon='delete' />
        </Popconfirm>
      )
    }
  ]))

  const tableTitle = (
    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 3 }}>
      <Crud
        buttons={['reload']}
        onReload={() => fetch()}
        style={{ marginRight: 5 }}
      />

      <Divider type='vertical' />

      <Dropdown
        overlay={
          <Menu onClick={e => requestNewFile(documentos.find(_ => _.iId.toString() === e.key))}>
            {documentos.map(template =>
              <Menu.Item key={template.iId}>
                <Icon type='link' style={{ marginRight: 5 }} />
                <span>{template.sNombre}</span>
              </Menu.Item>
            )}
          </Menu>
        }
        children={masterIdPending ? <Button type='primary'>ADJUNTAR</Button> : <span />}
      />
    </div>
  )

  return (
    <div>
      <div style={{ marginBottom: 15 }}>

      </div>

      <Table
        key='2'
        rowKey='iId'
        size='small'
        bordered={false}
        pagination={false}
        loading={loading}
        columns={columns}
        dataSource={records}
        title={() => tableTitle}
      />
    </div>
  )
}

/**
 *
 * @param {{ onClose?(): Function, docId: number }} props
 * @returns
 */
export function KernelAdjuntosModal(props) {
  return (
    <Modal
      title='ADJUNTOS'
      visible={!!props.docId}
      onOk={props.onClose}
      style={{ minWidth: '80%' }}
      onCancel={props.onClose}
      footer={[
        <Button
          key='cerrar'
          onClick={props.onClose}
          children='Cerrar'
        />
      ]}
      children={[
        <div key='1' style={{ marginBottom: 15 }}>
          <KernelAdjuntosTable {...props} />
        </div>
      ]}
    />
  )
}
